// Central registry of all YouTube video embeds on the site.
// Swap a youtubeId here and it updates everywhere automatically.
// All videos are hosted as Public on YouTube (free, unlimited streaming, no ads on embed).

export const videos = {
  // -------- HOMEPAGE PLACEMENTS --------
  aboutKrina: {
    youtubeId: "SgaYwTkDNXM",
    title: "All About Krina Panchal – The TMD Physio",
    description: "Meet Krina and learn what makes her approach different",
  },
  assessmentProcess: {
    youtubeId: "UQ0SIEWqDxo",
    title: "How I Assess a Patient",
    description: "A look inside Krina's thorough initial assessment",
  },

  // -------- SERVICE PAGE INTRO VIDEOS --------
  serviceIntros: {
    "tinnitus-management": {
      youtubeId: "M2MlN-SqXz0",
      title: "Understanding Somatic Tinnitus",
      description: "How jaw and neck dysfunction can drive tinnitus, and how physiotherapy helps.",
    },
    "headache-migraine-relief": {
      youtubeId: "fBaz-JhX6Ck",
      title: "Headaches & Acupuncture",
      description: "How acupuncture and dry needling can ease chronic headaches.",
    },
  },

  // -------- BY-MODALITY VIDEOS --------
  byModality: {
    "Dry Needling & Massage": {
      youtubeId: "7jtdo4lfiwI",
      title: "Dry Needling Explained",
    },
    "Low-Level Laser Therapy": {
      youtubeId: "Fae4eOyp4nU",
      title: "Low Level Laser Therapy",
    },
    "Joint Mobilisations": {
      youtubeId: "OolYoLdlFnc",
      title: "Mobilising the Jaw",
    },
    "Dean Watson Technique": {
      youtubeId: "1iU78g6Q03w",
      title: "The Dean Watson Technique",
    },
  },
};

// ===========================================================
//  VIDEOS LIBRARY (public /videos page)
//
//  Flat array of every video that should appear in the patient
//  resource hub. Add new entries here and they'll automatically
//  show up on /videos with the right category filter.
//
//  Fields:
//    - id           unique slug                          (required)
//    - youtubeId    YouTube video ID                     (required)
//    - title        short display title                  (required)
//    - description  1–2 sentence summary                 (required)
//    - category     one of VIDEO_CATEGORIES below        (required)
//    - source       "in-house" | "external"              (required)
//    - sourceName   e.g. "TED-Ed", "Bupa", "Dr Mike"     (only if source = external)
//    - featured     true to pin to top of library        (optional)
//
//  To add a new YouTube video found elsewhere:
//    1. Find the video on YouTube → click Share → Copy the YouTube ID
//       (the 11-char string in https://youtu.be/XXXXXXXXXXX)
//    2. Append a new object to the array below
//    3. Save — the video appears on /videos within seconds
//
//  No backend changes needed — this is a pure-frontend addition.
// ===========================================================

export const VIDEO_CATEGORIES = [
  { id: "all",          label: "All Videos" },
  { id: "intro",        label: "Meet the Clinic" },
  { id: "exercises",    label: "Exercises" },
  { id: "treatments",   label: "Treatment Demos" },
  { id: "education",    label: "Condition Education" },
  { id: "external",     label: "Recommended Resources" },
];

export const allVideos = [
  {
    id: "about-krina",
    youtubeId: "SgaYwTkDNXM",
    title: "All About Krina Panchal",
    description: "Meet Krina and learn what makes her approach different. A short personal introduction to the clinic.",
    category: "intro",
    source: "in-house",
    featured: true,
  },
  {
    id: "assessment-process",
    youtubeId: "UQ0SIEWqDxo",
    title: "How I Assess a Patient",
    description: "A look inside Krina's thorough initial assessment — what to expect at your first visit.",
    category: "intro",
    source: "in-house",
  },
  {
    id: "tinnitus-explained",
    youtubeId: "M2MlN-SqXz0",
    title: "Understanding Somatic Tinnitus",
    description: "How jaw and neck dysfunction can drive tinnitus, and how physiotherapy can help reduce it.",
    category: "education",
    source: "in-house",
  },
  {
    id: "headaches-acupuncture",
    youtubeId: "fBaz-JhX6Ck",
    title: "Headaches & Acupuncture",
    description: "How acupuncture and dry needling can ease chronic tension headaches and migraines.",
    category: "education",
    source: "in-house",
  },
  {
    id: "dry-needling",
    youtubeId: "7jtdo4lfiwI",
    title: "Dry Needling Explained",
    description: "What dry needling is, what it feels like, and the conditions it helps with.",
    category: "treatments",
    source: "in-house",
  },
  {
    id: "low-level-laser",
    youtubeId: "Fae4eOyp4nU",
    title: "Low-Level Laser Therapy",
    description: "Painless laser therapy to reduce inflammation and accelerate tissue healing.",
    category: "treatments",
    source: "in-house",
  },
  {
    id: "jaw-mobilisations",
    youtubeId: "OolYoLdlFnc",
    title: "Mobilising the Jaw",
    description: "Demonstration of gentle joint mobilisation techniques for restoring jaw movement.",
    category: "treatments",
    source: "in-house",
  },
  {
    id: "dean-watson-technique",
    youtubeId: "1iU78g6Q03w",
    title: "The Dean Watson Technique for Headaches",
    description: "The specialist manual-therapy approach Krina uses to diagnose and treat cervicogenic headaches.",
    category: "treatments",
    source: "in-house",
  },
];
